export default function highlightSquares(nuclides, nuclideOfInterest) {
    nuclides.filter(nuclide => nuclide.name === nuclideOfInterest.name)[0]["opacity"] = 1.0;
}
